import { useRouter } from 'next/router';

export enum TrackingSource {
  APTUNO = 'APTUNO',
  WHATSAPP = 'WHATSAPP',
}

export const useTrackingSource = () => {
  const router = useRouter();
  const utmMedium = router?.query['UTM_MEDIUM'] || router?.query['utm_medium'];

  return utmMedium?.toString().toUpperCase() === TrackingSource.WHATSAPP
    ? TrackingSource.WHATSAPP
    : TrackingSource.APTUNO;
};
